import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '../Icon/Icon.js';
import Text from '../Text/Text.js';
import Tooltip from '../Tooltip/Tooltip.js';
import { CommonClasses } from '../../commonClasses.js';

const DEFAULT_TOOLTIP_ICON = 'info';
const BASE_CLASS = 'nui-label-group';
const Classes = {
  BASE: BASE_CLASS,
  TEXT: `${BASE_CLASS}-text`,
  TOOLTIP: `${BASE_CLASS}-tooltip`,
  WARNING: `${BASE_CLASS}-warning`
};
const Label = ({
  className,
  hidden,
  hideLabel,
  htmlFor,
  label,
  labelElement,
  textProps,
  tooltip,
  tooltipProps = {},
  warningLabel = '',
  ...rest
}) => {
  if (hidden) return null;
  const maybeRenderTooltip = () => {
    const {
      icon = DEFAULT_TOOLTIP_ICON,
      withSup = false,
      ...restTooltipProps
    } = tooltipProps;
    if (!tooltipProps.content && !tooltip) return null;
    const iconContent = /*#__PURE__*/React__default.createElement(Icon, {
      name: icon,
      title: icon,
      fill: "primary"
    });
    const wrappedIcon = withSup ? /*#__PURE__*/React__default.createElement("sup", null, iconContent) : iconContent;
    return /*#__PURE__*/React__default.createElement(Tooltip, _extends({
      className: Classes.TOOLTIP,
      content: tooltip
    }, restTooltipProps), wrappedIcon);
  };
  const maybeRenderWarningLabel = () => {
    if (!warningLabel) return null;
    return /*#__PURE__*/React__default.createElement(Text, {
      size: "xsmall",
      className: Classes.WARNING
    }, warningLabel);
  };
  const textClassName = cx(Classes.TEXT, {
    [CommonClasses.ACCESSIBILITY_HIDDEN]: hideLabel
  });
  return /*#__PURE__*/React__default.createElement("label", _extends({
    className: cx(Classes.BASE, className),
    htmlFor: htmlFor
  }, rest), label && /*#__PURE__*/React__default.createElement(Text, _extends({
    typeStyle: "bold",
    size: "small",
    className: textClassName,
    ellipsized: true
  }, textProps), label), labelElement, maybeRenderTooltip(), maybeRenderWarningLabel());
};
Label.propTypes = {
  className: PropTypes.string,
  /** id of associated input */
  htmlFor: PropTypes.string.isRequired,
  /** doesn't render anything if true */
  hidden: PropTypes.bool,
  /** accessibly hide the label text */
  hideLabel: PropTypes.bool,
  label: PropTypes.node,
  /** Custom element to render inside a label, will not be wrapped in Text */
  labelElement: PropTypes.node,
  warningLabel: PropTypes.node,
  /** Props to pass into Text component */
  textProps: PropTypes.shape({}),
  /** shorthand for tooltipProps.content */
  tooltip: PropTypes.node,
  /** props that will be passed to the Tooltip component */
  tooltipProps: PropTypes.shape({
    content: PropTypes.node,
    icon: PropTypes.string,
    position: PropTypes.string,
    withSup: PropTypes.bool
  })
};
Label.displayName = 'NuiLabel';
var Label$1 = Label;

export { Label$1 as default };
